import { useEffect } from "react";
import { initLenis } from "@/lib/scroll";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { TrustStrip } from "@/components/site/TrustStrip";
import { Services } from "@/components/site/Services";
import { Solutions } from "@/components/site/Solutions";
import { OfflineFlow } from "@/components/site/OfflineFlow";
import { WhyAnimexa } from "@/components/site/WhyAnimexa";
import { Process } from "@/components/site/Process";
import { Pricing } from "@/components/site/Pricing";
import { Portfolio } from "@/components/site/Portfolio";
import { Founder } from "@/components/site/Founder";
import { CtaBand } from "@/components/site/CtaBand";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import AdminPage from "@/components/site/AdminPage";

function App() {
    useEffect(() => {
        initLenis();
    }, []);

    if (window.location.pathname.startsWith("/admin")) {
        return <AdminPage />;
    }

    return (
        <div className="bg-[#07090E] text-slate-100 min-h-screen antialiased">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <TrustStrip />
                <Services />
                <Solutions />
                <OfflineFlow />
                <WhyAnimexa />
                <Process />
                <Pricing />
                <Portfolio />
                <Founder />
                <CtaBand />
                <Faq />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
